var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { reclamationSchema, } from "../../lib/schemas/reclamation";
import { registerReclamation } from "../../lib/api/reclamations";
import { buildReclamationPayload } from "./buildReclamationPayload";
import { useWebgateAuth } from "../../infrastructure/providers/useWebgateAuth";
import { getApiErrorMessage } from "../../utils/apiError";
export function useReclamationForm() {
    var _this = this;
    var navigate = useNavigate();
    var citizenId = useWebgateAuth().citizenId;
    var _a = useState(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = useState(null), submitError = _b[0], setSubmitError = _b[1];
    var methods = useForm({
        resolver: yupResolver(reclamationSchema),
        defaultValues: {
            category: "",
            companyName: "",
            cnpj: "",
            involvedValue: "",
            eventDate: "",
            eventLocation: "",
            description: "",
            possibleSolution: "",
            files: [],
        },
    });
    var control = methods.control, handleSubmit = methods.handleSubmit, setValue = methods.setValue;
    var onSubmit = function (values) { return __awaiter(_this, void 0, Promise, function () {
        var files, dto, response, protocol, reclamationId, params, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setSubmitError(null);
                    setIsSubmitting(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    files = (_a = values.files) !== null && _a !== void 0 ? _a : [];
                    dto = buildReclamationPayload(values, citizenId !== null && citizenId !== void 0 ? citizenId : "");
                    return [4 /*yield*/, registerReclamation(dto, files)];
                case 2:
                    response = _d.sent();
                    protocol = (_b = response === null || response === void 0 ? void 0 : response.protocol) !== null && _b !== void 0 ? _b : "";
                    reclamationId = (_c = response === null || response === void 0 ? void 0 : response.reclamation) === null || _c === void 0 ? void 0 : _c.id;
                    params = new URLSearchParams({ protocol: protocol });
                    if (reclamationId)
                        params.set("id", reclamationId);
                    navigate("/reclamation/success?".concat(params.toString()));
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    console.error("Erro ao enviar reclamação:", error_1);
                    setSubmitError(getApiErrorMessage(error_1, "Erro ao processar sua reclamação. Tente novamente."));
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        methods: methods,
        control: control,
        handleSubmit: handleSubmit,
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        submitError: submitError,
        setValue: setValue,
    };
}
